












































import Vue from 'vue';
import Component from 'vue-class-component';
import { db } from '@/plugins/firebase';
import { Project } from '@/types';

@Component
export default class RightSideMenu extends Vue {
  miniVariant = false;

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (window.innerWidth > 600) {
      this.miniVariant = false;
    } else {
      this.miniVariant = true;
    }
  }
}
